<template>
  <div class="px-0 mx-0">    
    <div v-if="loading || isLoading" class="col-md-12 text-center mb-4">
      <h5>Cargando....</h5>
    </div>
    <div v-else class="border rounded shadow p-2">      
      <form @submit.prevent="saveDog">
        <div class="row mb-1">
          <div class="col-md-12">
            <button
              type="submit"
              data-toggle="tooltip"
              data-placement="top"
              class="btn btn-sm btn-success mt-2 float-right pt-2 pb-2 btn-w"
            >
              {{ $t("guardar cambios") }}
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12" v-if="editing">
            <dog-title-badge
              :titulos="objDog.dog_with_titles"
              @emitDeleteDogTitleBadge="deleteDogTitleBadge"
              @emitCreateDogTitleBadge="createDogTitleBadge"
            ></dog-title-badge>
          </div>
        </div>
        <!-- Nombre del perro -->
        <div class="row mb-1">
          <div class="col-md-12">
            <label class="font-weight-normal">
              {{ $t("nombre") }}
              <span class="required">*</span>
            </label>
            <input
              type="text"
              class="woocommerce-Input woocommerce-Input--text input-text"
              v-model="objDog.name"
            />
          </div>
        </div>

        <div class="row mb-0 pb-0">
          <div class="col-md-12 mb-0 pb-0 my-1">
            Raza - Variedad - Subvariedad 
            <input
              v-model="objDog.dog_breed_id"
              class="mi-buscador"
              type="hidden"
            />
            <input
              v-if="!mostrarBuscadorRaza"
              v-model="objDog.breed"
              class="mi-buscador"
              type="text"
              @click="mostrarBuscadorRaza = !mostrarBuscadorRaza"
            />
          </div>
        </div>
        <!-- COMPONENTE DE BUSQUEDA DE RAZAS -->
        <dog-breeds-search
          v-if="mostrarBuscadorRaza"
          :selected="objDog.dog_breed_id"
          :lista="dataBreeds"
          @emitDogId="seleccionarRaza"
          @emitCancelarBuscarRaza="mostrarBuscadorRaza = false"
        ></dog-breeds-search>     

        <!-- Fecha de nacimiento  | Sexo del perro -->
        <div class="row mb-1">
          <div class="col-md-6">
            <label class="font-weight-normal">
              {{ $t("fecha nacimiento") }}
              <span class="required">*</span>
            </label>
            <input
              type="date"
              class="woocommerce-Input woocommerce-Input--text input-text"
              v-model="fecha"
            />
          </div>
          <div class="col-md-6">
            <label class="font-weight-normal">
              {{ $t("sexo") }}
              <span class="required">*</span>
            </label>
            <select v-model="objDog.sex_id">
              <option selected>...</option>
              <option value="1">{{ $t("macho") }}</option>
              <option value="2">{{ $t("hembra") }}</option>
            </select>
          </div>
        </div>

        <!-- libro tabla dog_books -->
        <div class="row mb-1">
          <div class="col-md-6">
            <label class="font-weight-normal">
              {{ $t("libro") }}
              <span class="required">*</span>
            </label>
            <p class="form-row form-row-wide validate-required">
              <select v-if="!loading" v-model="objDog.dog_book_id">
                <option></option>
                <option v-for="bk in dogBooks" :key="bk.id" :value="bk.id">{{
                  bk.book
                }}</option>
              </select>
            </p>
          </div>
          <div class="col-md-6">
            <label class="font-weight-normal">
              {{ $t("numero") }}
              <span class="required">*</span>
            </label>
            <input
              type="text"
              class="woocommerce-Input woocommerce-Input--text input-text"
              v-model="objDog.book_number"
            />
          </div>
        </div>

        <!-- Numero de microchip | tipo cola -->
        <div class="row mb-1">
          <div class="col-md-6">
            <label class="font-weight-normal">
              {{ $t("microchip") }}
              <span class="required">*</span>
            </label>
            <input
              type="text"
              class="woocommerce-Input woocommerce-Input--text input-text"
              v-model="objDog.chip"
            />
          </div>

          <div class="col-md-6">
            <label class="font-weight-normal">
              {{ $t("cola") }} {{ $t("CC/SC") }}
              <span class="required">*</span>
            </label>
            <select v-model.number="objDog.cc_anuro">
              <option value="1">{{ $t("si") }}</option>
              <option value="0">{{ $t("no") }}</option>
            </select>
            <label class="font-weight-normal" v-if="objDog.cc_anuro === 1">
              {{ $t("numero") }}
              <span class="required">*</span>
            </label>
            <input
              v-if="objDog.cc_anuro === 1"
              type="text"
              class="mt-1 woocommerce-Input woocommerce-Input--text input-text"
              v-model="objDog.cod_cc"
            />
          </div>
        </div>

        <!-- padre del perro -->
        <div class="row mb-1">
          <div class="col-md-12">
            <label class="font-weight-normal">
              {{ $t("padre") }} :
              <span class="required">*</span>
            </label>
            <input
              type="text"
              class="woocommerce-Input woocommerce-Input--text input-text"
              v-model="objDog.padre"
            />
          </div>
        </div>

        <!-- madre del perro -->
        <div class="row mb-1">
          <div class="col-md-12">
            <label class="font-weight-normal">
              {{ $t("madre") }} :
              <span class="required">*</span>
            </label>
            <input
              type="text"
              class="woocommerce-Input woocommerce-Input--text input-text"
              v-model="objDog.madre"
            />
          </div>
        </div>

        <!-- criador del perro -->
        <div class="row mb-1 mt-3" v-if="editing">
          <div class="col-md-12">
            <label class="font-weight-normal">
              {{ $t("criadores") }} ({{ objDog.breeders.length }}):
              <button
                class="btn btn-sm bg-primary btn-work"
                @click.prevent="showNewBreeder(true)"
                v-if="newCobreeder === false && editingBreeder.show === false"
              >
                <b>+</b>
              </button>
              <button
                class="btn btn-sm bg-danger btn-work"
                @click.prevent="showNewBreeder(false)"
                v-if="newCobreeder || editingBreeder.show"
              >
                <b>-</b>
              </button>
              <!--   <a class="btn btn-default btn-work" href="#" @click.prevent="addNewBreeder">+</a> -->
            </label>
          </div>
        </div>
        <div v-if="editing === true && newCobreeder === true">
          <dog-cobreeder
            :datos="null"
            :dogId="objDog.id"
            :newReg="true"
            @emitCrearCriador="crearCriador"
            @emitCancelarFormCriador="cancelarFormCriador"
          ></dog-cobreeder>
        </div>
        <!-- Editando un criador -->
        <div v-if="editing === true && editingBreeder.show === true">
          <dog-cobreeder
            :datos="editingBreeder.data"
            :dogId="objDog.id"
            :editing="true"
            :newReg="false"
            @emitEditarRegCriador="editarRegCriador"
            @emitCancelarFormCriador="cancelarFormCriador"
          ></dog-cobreeder>
        </div>
        <div v-for="breeder in objDog.breeders" :key="breeder.id">
          <dog-cobreeder
            :datos="breeder"
            :dogId="objDog.id"
            :list="true"
            @emitEditarCriador="editarCriador"
            @emitEliminarCriador="eliminarCriador"
            @emitCancelarFormCriador="cancelarFormCriador"
          ></dog-cobreeder>
        </div>

        <!-- copropietario del perro -->
        <div class="row mb-1 mt-3" v-if="editing">
          <div class="col-md-12">
            <label class="font-weight-normal">
              {{ $t("copropietarios") }} ({{ objDog.cowners.length }}):
              <button
                class="btn btn-sm bg-primary btn-work"
                @click.prevent="showNewCowner(true)"
                v-if="!newCoowner && !editingCowner.show"
              >
                <b>+</b>
              </button>
              <button
                class="btn btn-sm bg-danger btn-work"
                @click.prevent="showNewCowner(false)"
                v-if="newCoowner || editingCowner.show"
              >
                <b>-</b>
              </button>
              <!--   <a class="btn btn-default btn-work" href="#" @click.prevent="addNewBreeder">+</a> -->
            </label>
          </div>
        </div>

        <div v-if="editing === true && newCoowner === true">
          <dog-cowner
            :datos="null"
            :dogId="objDog.id"
            :newReg="true"
            @emitCrearCopropietario="crearCopropietario"
            @emitCancelarFormCopropietario="cancelarFormCopropietario"
          ></dog-cowner>
        </div>
        <!-- Editando un copropietario -->
        <div v-if="editing === true && editingCowner.show === true">
          <dog-cowner
            :datos="editingCowner.data"
            :dogId="objDog.id"
            :editing="true"
            :newReg="false"
            @emitEditarRegCopropietario="editarRegCopropietario"
            @emitCancelarFormCopropietario="cancelarFormCopropietario"
          ></dog-cowner>
        </div>
        <!-- lista de copropietarios -->
        <div
          v-for="cowner in objDog.cowners"
          :key="cowner.id + '_' + cowner.name"
        >
          <dog-cowner
            :datos="cowner"
            :dogId="objDog.id"
            :list="true"
            @emitEditarCopropietario="editarCopropietario"
            @emitEliminarCopropietario="eliminarCopropietario"
            @emitCancelarFormCopropietario="cancelarFormCopropietario"
          ></dog-cowner>
        </div>

        <div class="clear"></div>
      </form>
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/icon?family=Material+Icons"
      />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css"
      />
    </div>
    <fab
      v-if="!isLoading && !loading"
      :position="position"
      :bg-color="bgColor"
      :actions="fabActions"
      :icon-size="size"
      @cache="saveDog"
      @cancel="cancelFormDog"
      :main-tooltip="tooltip"
    ></fab>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { isEqual } from "lodash";
import fab from "vue-fab";
/* import Vue from "vue"; */
/* import DogBreedsList from "./Dog-breeds.vue"; */

/* import vSelectPage from "v-selectpage"; */
import { SelectPage } from "v-selectpage";
import dogCobreeder from "./Dog-CoBreeder-comp";
import dogCowner from "./Dog-Coowner-comp.vue";
import dogTitleBadge from "./Dog-title-badge-comp";
import dogBreedsSearch from "./Dog-breeds-search";

/* Vue.use(vSelectPage, {
  language: true
}); */

//todo: 07-08-2019 Controlar los coopropietarios, titulos <- componentes
export default {
  name: "Dog-form",
  components: {
    /* "v-selectpage": SelectPage, */
    dogCobreeder,
    dogCowner,
    dogTitleBadge,
    fab,
    dogBreedsSearch
  },
  props: ["indexEdit", "editing", "lang"],
  data() {
    return {
      /* mostrar buscador razas */
      mostrarBuscadorRaza: false,
      /* fab button */
      bgColor: "#C00B3D",
      position: "bottom-right",
      size: "medium",
      tooltip: this.$t("acciones"),
      fabActions: [
        {
          name: "cancel",
          icon: "cancel",
          tooltip: this.$t("cancelar")
        },
        {
          color: "#28a745",
          name: "cache",
          icon: "save",
          tooltip: this.$t("guardar")
        }
      ],
      /* fin fab button */
      newCoowner: false,
      newCobreeder: false,
      editingBreeder: {
        show: false,
        data: null
      },
      editingCowner: {
        show: false,
        data: null
      },
      objDog: {
        name: null,
        dog_breed_id: null,
        birth_date: null,
        sex_id: null,
        padre: null,
        madre: null,
        criador: null,
        chip: null,
        dog_book_id: null,
        book_number: null,
        cc_anuro: null,
        cod_cc: null
      },
      showDogList: false,
      miNum: "96",
      isLoading: true,
      buscarPerroRaza: null
    };
  },
  methods: {
    ...mapActions("dog", [
      "getDogBreeds",
      "getDogBooks",
      "createUserDog",
      "updateUserDog",
      "getUserDogById",
      "callCrearCriador",
      "callActualizarCriador",
      "callEliminarCriador",
      "callCrearCopropietario",
      "callActualizarCopropietario",
      "callEliminarCopropietario",
      "callInsertDogTitle",
      "callDeleteDogTitle"
    ]),
    /* crear un titulo para el perrete */
    createDogTitleBadge(e) {
      console.log(e);
      //comprobamos si hay cambios en los datos del perro
      const hayCambios = !isEqual(this.objDog, this.getCurrentEditDog);
      const datos = { ...e, dog_id: this.objDog.id };
      console.log(datos);
      this.callInsertDogTitle(datos).then(res => {
        console.log(res, datos, hayCambios);
        //hemos detectado cambios por tanto actualizamod
        if (hayCambios) {
          this.updateUserDog({ ...this.objDog, silent: true });
        } else {
          this.getUserDogById({ dogId: this.indexEdit, silent: true }).then(
            res2 => {
              this.objDog = JSON.parse(JSON.stringify(res2));
            }
          );
        }
      });
    },
    /* Eliminar un titulo de un perro */
    deleteDogTitleBadge(e) {
      console.log("eliminar un titulo de un perro", e);
      if (this.objDog.id === e.dogId) {
        this.callDeleteDogTitle(e)
          .then(res => {
            return this.getUserDogById({ dogId: this.indexEdit, silent: true });
          })
          .then(res2 => {
            console.log(res2);
            this.objDog = res2;
          });
      }
    },
    /* actualizarDatosAl modificar componentes */
    actualizarDatos() {
      this.getUserDogById({ dogId: this.indexEdit, silent: true }).then(res => {
        this.objDog = JSON.parse(JSON.stringify(this.getCurrentEditDog));
      });
    },
    /* CREAR UN NUEVO CRIADOR */
    crearCriador(e) {
      let datos = { ...e, dogId: this.objDog.id };
      this.callCrearCriador(datos).then(res => {
        this.actualizarDatos();
        this.newCobreeder = false;
      });
    },
    /* editar un criador */
    editarRegCriador(e) {
      let datos = { ...e, dogId: this.objDog.id };
      this.callActualizarCriador(datos).then(res => {
        this.editingBreeder.show = false;
      });
      return;
      this.editingBreeder.show = false;
      this.editingBreeder.data = null;
    },
    /* ELIMINAR CRIADOR */
    eliminarCriador(e) {
      if (this.editingBreeder.show || this.newCobreeder) {
        return;
      }
      this.callEliminarCriador(e.id)
        .then(res => {
          this.actualizarDatos();
        })
        .catch(error => {
          console.log("error eliminando un reg criador", error);
        });
    },
    /* mostar editar criador */
    editarCriador(e) {
      if (this.editingCowner.show || this.newCoowner) {
        return;
      }

      this.editingBreeder.show = true;
      this.editingBreeder.data = e;
    },
    /* form Nuevo criador */
    showNewBreeder(state) {
      if (state === true) {
        this.newCobreeder = true;
      } else {
        this.newCobreeder = false;
        this.editingBreeder.show = false;
      }
    },
    /* cancelar form criador */
    cancelarFormCriador() {
      this.editingBreeder.data = false;
      this.editingBreeder.show = false;
      this.newCobreeder = false;
    },
    /* CREAR UN NUEVO Copropietario */
    crearCopropietario(e) {
      let datos = { ...e, dogId: this.objDog.id };
      this.callCrearCopropietario(datos).then(res => {
        this.actualizarDatos();
        this.newCoowner = false;
      });
    },
    /* editar un Copropietario */
    editarRegCopropietario(e) {
      let datos = { ...e, dogId: this.objDog.id };
      this.callActualizarCopropietario(datos).then(res => {
        console.log("actualizacion res", res);
      });
      this.editingCowner.show = false;
      this.editingCowner.data = null;
    },
    /* ELIMINAR Copropietario */
    eliminarCopropietario(e) {
      if (this.editingCowner.show || this.newCoowner) {
        return;
      }
      this.callEliminarCopropietario(e.id).then(res => {
        this.actualizarDatos();
      });
    },
    /* mostar editar Copropietario */
    editarCopropietario(e) {
      if (this.editingCowner.show || this.newCoowner) {
        return;
      }
      this.editingCowner.show = true;
      this.editingCowner.data = e;
    },
    /* form Nuevo Copropietario */
    showNewCowner(state) {
      if (state === true) {
        this.newCoowner = true;
      } else {
        this.newCoowner = false;
        this.editingCowner.show = false;
      }
    },
    /* cancelar form Copropietario */
    cancelarFormCopropietario() {
      this.editingCowner.data = false;
      this.editingCowner.show = false;
      this.newCoowner = false;
    },

    //TODO:PONER UN ALERT EN CONDICIONES
    createDog() {
      if (
        this.objDog.cc_anuro === 1 &&
        (this.objDog.cod_cc === null || this.objDog.cod_cc === "")
      ) {
        alert(this.$t("error debe agregar los datos de cola cortada"));
        return;
      }
      this.createUserDog(this.objDog);
    },
    editDog() {
      if (
        this.objDog.cc_anuro === 1 &&
        (this.objDog.cod_cc === null || this.objDog.cod_cc === "")
      ) {
        alert(this.$t("error debe agregar los datos de cola cortada"));
        return;
      }
      this.updateUserDog(this.objDog);
      this.cancelFormDog();
    },
    cancelFormDog() {
      this.$emit("emitEditingOrCreating", false);
    },
    saveDog() {
      if (this.editing) {
        this.editDog();
      } else {
        this.createDog();
      }
    },
    seleccionarRaza(id) {     
      this.objDog.dog_breed_id = id;
      this.mostrarBuscadorRaza = false;
      this.buscarPerroRaza = null;

    }
  },
  computed: {
    ...mapState("dog", ["loading", "dogBreeds", "dogBooks"]),
    ...mapGetters("dog", [
      "getLocalDogBreeds",
      "getLocalDogBooks",
      "getCurrentEditDog"
    ]),
    fecha: {
      set(val) {
        this.objDog.birth_date = val;
      },
      get() {
        if (this.objDog.birth_date != null) {
          return this.objDog.birth_date.slice(0, 10);
        }
      }
    },
    dataBreeds: function() {
      if (this.dogBreeds != undefined && this.dogBreeds !== null) {
        let data = [];

        let columns = [
          { title: this.$t("nombre"), data: "name" },
          { title: this.$t("variedad"), data: "variety" },
          { title: this.$t("subvariedad"), data: "subvariety" }
        ];

        this.dogBreeds.forEach(e => {
          let nombre = this.$options.filters.filterTranslateBreed(
            "",
            null,
            e.translations,
            this.lang,
            "name"
          );
          let variedad = this.$options.filters.filterTranslateBreed(
            "",
            null,
            e.translations,
            this.lang,
            "variety"
          );
          let subVariedad = this.$options.filters.filterTranslateBreed(
            "",
            null,
            e.translations,
            this.lang,
            "subvariety"
          );

          let row = {
            id: e.id.toString(),
            name: nombre,
            variety: variedad,
            subvariety: subVariedad
          };
          data.push(row);
        });

        return { data, columns };
      }
    },
    buscarFiltrado() {
      if (this.buscarPerroRaza === null) {
        return;
      }
      let filtro = this.buscarPerroRaza.toUpperCase();

      const miFiltro = this.dataBreeds.data.filter(x => {
        //hay filtro multiple
        let filtros = [];
        if (filtro.trim().includes("*")) {
          filtros = filtro.trim().split("*");
        }
        if (filtros.length > 1) {
          if (filtros[filtros.length - 1].trim() === "*") filtros.pop();
          const raza = filtros.some(f => x.name.toUpperCase().includes(f));
          const variedad = filtros.some(f =>
            x.variety.toUpperCase().includes(f)
          );
          const subVariedad = filtros.some(f =>
            x.subvariety.toUpperCase().includes(f)
          );
          if (raza && variedad && subVariedad) {
            return x;
          }
          if (raza && variedad && !subVariedad) {
            return x;
          }
          if (raza && !variedad && subVariedad) {
            return x;
          }
        } else {
          if (
            x.name.toUpperCase().includes(filtro) ||
            x.variety.toUpperCase().includes(filtro) ||
            x.subvariety.toUpperCase().includes(filtro)
          )
            return x;
        }
      });

      return miFiltro.length > 20 ? miFiltro.splice(0, 20) : miFiltro;
    }
  },
  watch: {
    /*  getCurrentEdit_Dog: function(val) {
      this.objDog = JSON.parse(JSON.stringify(val));
    }, */
    lang: function() {
      console.log("Esto cambia....");
    }
  },
  mounted() {
    if (this.editing) {
      this.getUserDogById({ dogId: this.indexEdit }).then(res => {
        this.objDog = JSON.parse(JSON.stringify(this.getCurrentEditDog));
        this.getDogBreeds();
        this.getDogBooks();
        this.isLoading = false;
      });
    } else {
      console.log("creando un nuevo perrete");
      this.isLoading = false;
    }
  }
};
</script>

<style scoped>
table.mi-tabla {
  font-size: 0.7em;
  text-align: left;
}
table.mi-tabla td {
  text-align: left;
  height: 35px;
  padding: 0px;
  padding-left: 5px;
  min-height: 35px;
}
table.mi-tabla tbody tr:hover {
  background-color: red;
  color: white;
  font-weight: bold;
  cursor: pointer;
}
table.sp-table tbody tr td {
  text-align: left !important;
  color: red;
}
table.sp-table tr {
  min-width: 700px !important;
  border-bottom: 1px solid #ccc !important;
}
button.mini {
  font-size: 20px;
  color: white !important;
  min-width: 25px !important;
  max-width: 40px !important;
  min-height: 25px !important;
  max-height: 25px !important;
  padding: 0px 1px 4px 0px;
}
.btn-work {
  width: 25px !important;
  min-width: 25px !important;
  height: 25px;
  margin: 0 auto;
  padding: 0;
  padding-left: 2px;
  font-size: 1.8em;
  line-height: 25px;
  text-align: center !important;
}
.btn-work:hover {
  background-color: red !important;
  color: black;
}
input {
  min-height: 20px;
  height: 34px !important;
}
input.mi-buscador {
  background-color: white !important;
  border: 1px solid #ccc !important;
  padding: 1px 0px 1px 10px !important;
  font-size: 16px;
}
select {
  height: 34px !important;
  padding-top: 1px;
  padding-bottom: 1px;
}
</style>
